module.exports = __webpack_public_path__ + "img/스피릿.77b25212.png";